import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MSAL_CONFIG, MSAL_CONFIG_ANGULAR } from '@azure/msal-angular';
import { Constant } from '@shared/utilities/constant';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'zone.js/dist/zone';
import { ClientService } from '@shared/services/client.service';

export function loadConfig(
  clientService: ClientService
): Promise<any> {
 
    // Fetch static config and branding files
    return Promise.all([
      fetch('/assets/config.json').then(response => response.json()),
      fetch('/assets/branding.json').then(response => response.json())
    ]).then(([config, brandingConfig]) => {

    // Fetch the clientId and domain dynamically

      return Promise.all([
        clientService.manipulatedClientCode(),
        clientService.getDomainFromHost()
      ]).then(([clientId, domain]) => {

      // Transform branding keys to lowercase (or any other transformation you need)
      const transformedObject = clientService.transformKeysToLowerCase(brandingConfig);

     
      // Replace placeholders in the config with dynamic values
      config.authConfig.id4Config.client_id = config.authConfig.id4Config.client_id.replace("{{ClientIDPlaceHolder}}", clientId);
      config.authConfig.id4Config.redirect_uri = config.authConfig.id4Config.redirect_uri.replace("{{Host}}", domain);
      config.authConfig.id4Config.post_logout_redirect_uri = config.authConfig.id4Config.post_logout_redirect_uri.replace("{{Host}}", domain);
      config.MemberPortalUrl = config.MemberPortalUrl.replace("{{Host}}", domain);

      // Use the appropriate branding config for the given clientId
    
      const brandingConfigData = transformedObject[clientId];

      sessionStorage.setItem(Constant.clientCode, brandingConfigData.client_name);

      // Enable production mode if in production environment
      if (environment.production) {
        enableProdMode();
      }

      // Bootstrap Angular app with provided configuration values
      platformBrowserDynamic([
        { provide: Constant.appConfig, useValue: config },
        { provide: Constant.configurations, useValue: config.authConfig },
        { provide: MSAL_CONFIG, useValue: config.authConfig.aadConfig.config },
        { provide: MSAL_CONFIG_ANGULAR, useValue: config.authConfig.aadConfig.angularConfig },
        { provide: Constant.brandingConfig, useValue: brandingConfigData }
      ])
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
    });
  });
}

loadConfig(new ClientService());


